import { render, staticRenderFns } from "./SideCountdown3s.vue?vue&type=template&id=555f210c&scoped=true&"
import script from "./SideCountdown3s.vue?vue&type=script&lang=js&"
export * from "./SideCountdown3s.vue?vue&type=script&lang=js&"
import style0 from "./SideCountdown3s.vue?vue&type=style&index=0&id=555f210c&scoped=true&lang=css&"
import style1 from "./SideCountdown3s.vue?vue&type=style&index=1&id=555f210c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555f210c",
  null
  
)

export default component.exports